import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { ChartDataset, TooltipCallbacks } from 'chart.js';
import { _DeepPartialObject } from 'chart.js/dist/types/utils';
import { AnleggMaaned } from 'src/app/services/forbruk/forbruk.types';
import { monthsShort } from 'src/app/utils/date-utils';
import {
  labelTooltipCallback,
  titleTooltipCallback
} from '../../../../forbruk/charts/forbruk-charts-utils';
import { hasChanged } from 'src/app/utils/change-utils';

@Component({
  selector: 'app-month-chart-price',
  templateUrl: './month-chart-price.component.html',
  styleUrls: ['./month-chart-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonthChartPriceComponent implements OnInit, OnChanges {
  @Input() selectedDate: Date;
  @Input() valgtAnlegg: AnleggMaaned;
  @Input() isStromstotteToggled: boolean;

  useCurrentYear: boolean;
  usePreviousYear: boolean;
  dataSets: ChartDataset<'line'>[];
  labels: string[];
  title: string;
  tooltipCallbacks: _DeepPartialObject<TooltipCallbacks<'line'>>;
  stotte: number[] = [];

  constructor() {}

  ngOnInit(): void {
    if (this.valgtAnlegg && this.selectedDate) {
      this.getChartData();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.valgtAnlegg &&
      this.selectedDate &&
      hasChanged([
        changes?.valgtAnlegg,
        changes?.selectedDate,
        changes?.isStromstotteToggled
      ])
    ) {
      this.getChartData();
    }
  }

  getChartData() {
    this.dataSets = [];
    this.labels = [];
    const selectedYear = this.selectedDate?.getFullYear();
    const pricedatakraft = new Array(12);
    const pricedatanett = new Array(12);

    // Plusskunde produksjon
    let plusskundedataFound = false;
    const belopPluss = new Array(12);

    this.title = 'Kostnad ' + selectedYear;
    this.labels = monthsShort;
    this.tooltipCallbacks = {
      label: (tt) => labelTooltipCallback(tt, 'kr'),
      title: (tt) =>
        titleTooltipCallback(tt, 'month', 'kr', 'forbruk_tooltip_chart2')
    };

    this.stotte = [];

    this.valgtAnlegg.maanedVerdiList
      .filter((v) => v.aar === selectedYear)
      .map((element) => {
        pricedatakraft[element.mndNr - 1] = element.belopKraft || 0;
        pricedatanett[element.mndNr - 1] = element.belopNettleie || 0;

        if (this.isStromstotteToggled) {
          this.stotte[element.mndNr - 1] = element.stromstotte || 0;
        }

        if (this.valgtAnlegg.plusskunde) {
          const plussEarned = element.belopPlussverdi
            ? Math.abs(element.belopPlussverdi)
            : 0;

          if (plussEarned) {
            plusskundedataFound = true;
            belopPluss[element.mndNr - 1] = plussEarned;
          } else {
            belopPluss[element.mndNr - 1] = 0;
          }
        }
      });

    if (this.stotte.reduce((a, b) => Math.abs(a + b), 0) > 0) {
      let stotteKraft: number[] = [];
      for (let i = 0; i < pricedatakraft.length; i++) {
        stotteKraft.push(pricedatakraft[i] - Math.abs(this.stotte[i]));
      }
      if (stotteKraft.some((x) => !Number.isNaN(x))) {
        this.dataSets.push({
          label: 'Strøm inkl. støtte',
          pointStyle: 'line',
          fill: false,
          backgroundColor: '#002987',
          borderColor: '#002987',
          borderWidth: 2,
          pointRadius: 1,
          borderDash: [5, 5],
          data: stotteKraft
        });
      }
    }

    this.dataSets.push({
      label: 'Strøm',
      pointStyle: 'circle',
      fill: false,
      backgroundColor: '#002987',
      borderColor: '#002987',
      borderWidth: 2,
      pointRadius: 1,
      data: pricedatakraft
    });
    if (this.valgtAnlegg.gjennomfakturering) {
      this.dataSets.push({
        label: 'Nettleie',
        pointStyle: 'circle',
        fill: false,
        backgroundColor: '#ff80ff',
        borderColor: '#ff80ff',
        borderWidth: 2,
        pointRadius: 1,
        data: pricedatanett
      });
    }
    if (plusskundedataFound) {
      this.dataSets.push({
        label: 'Inntekt Plusskunde',
        pointStyle: 'circle',
        fill: false,
        backgroundColor: '#26b41b',
        borderColor: '#26b41b',
        borderWidth: 2,
        pointRadius: 1,
        data: belopPluss
      });
    }
  }
}
